module.exports = __webpack_public_path__ + "static/media/doorWhite.b00dc688.svg";